/**
 * Build unique participant list from ticket API data (creator + reply users).
 */
export const getTicketParticipants = (ticket) => {
  if (ticket.participants && Array.isArray(ticket.participants)) {
    return ticket.participants.map((p) => ({
      user_id: p.id || p.user_id,
      username: p.username || "مستخدم",
      first_name: p.first_name,
      last_name: p.last_name,
      email: p.email,
      profile_picture: p.profile_picture,
      avatar: p.avatar || p.profile_picture,
    }));
  }

  const participants = [];
  const creator =
    ticket.add_by_user_id ||
    ticket.user ||
    ticket.add_by_user ||
    ticket.created_by;

  if (creator) {
    participants.push({
      user_id: creator.id || creator.user_id,
      username: creator.username || creator.user_name || "مستخدم",
      first_name: creator.first_name,
      last_name: creator.last_name,
      email: creator.email || creator.user_email,
      profile_picture: creator.profile_picture,
      avatar: creator.avatar || creator.profile_image || creator.image,
    });
  }

  if (ticket.replies && Array.isArray(ticket.replies)) {
    ticket.replies.forEach((reply) => {
      const u = reply.user;
      if (u?.username || reply.user_name || reply.username) {
        participants.push({
          user_id: u?.id || reply.user_id,
          username:
            u?.username || reply.user_name || reply.username || "مستخدم",
          first_name: u?.first_name,
          last_name: u?.last_name,
          email: u?.email || reply.email,
          profile_picture: u?.profile_picture,
          avatar: reply.avatar || u?.profile_picture,
        });
      }
    });
  }

  return participants;
};

export const getPriorityColor = (priority) => {
  switch (priority) {
    case "urgent":
    case "high":
      return "error";
    case "medium":
      return "warning";
    case "low":
      return "success";
    default:
      return "default";
  }
};

export const getPriorityLabelKey = (priority) => {
  switch (priority) {
    case "low":
      return "search.priority.low";
    case "medium":
      return "search.priority.medium";
    case "high":
      return "search.priority.high";
    case "urgent":
      return "search.priority.urgent";
    default:
      return "search.priority.medium";
  }
};
